import {
  LOGIN_ERROR,
  LOGIN_START,
  LOGIN_RESET_ERROR,
  LOAD_ACCOUNT,
  LOGOUT_USER,
} from '../actions/loginActions';

const initialState = {
  error: null,
  message: '',
  content: '',
  isLoading: false,
  authenticated: null,
  role: null,
};

export function login(state = initialState, action) {
  switch (action.type) {
    case LOGIN_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case LOAD_ACCOUNT:
      return {
        ...state,
        authenticated: true,
        isLoading: false,
        role: action.role,
      };
    case LOGOUT_USER:
      return {
        ...state,
        authenticated: false,
        isLoading: false,
        role: '',
      };
    case LOGIN_ERROR:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case LOGIN_RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
}
